(function () {
  var SW_DATA = {
    S1500: [
      { pct: 10, speed: 2.5, power: 32 },
      { pct: 20, speed: 3.5, power: 54 },
      { pct: 30, speed: 4.2, power: 113 },
      { pct: 40, speed: 5.0, power: 120 },
      { pct: 50, speed: 6.0, power: 345 },
      { pct: 60, speed: 7.0, power: 535 },
      { pct: 70, speed: 8.0, power: 832 },
      { pct: 80, speed: 9.5, power: 1198 },
      { pct: 90, speed: 10.0, power: 1495 },
      { pct: 100, speed: 10.0, power: 1528 }
    ],

    S3000: [
      { pct: 10, speed: 1.0, power: 30 },
      { pct: 20, speed: 3.0, power: 71 },
      { pct: 30, speed: 5.0, power: 157 },
      { pct: 40, speed: 6.0, power: 314 },
      { pct: 50, speed: 7.0, power: 552 },
      { pct: 60, speed: 8.0, power: 948 },
      { pct: 70, speed: 9.0, power: 1434 },
      { pct: 80, speed: 11.0, power: 2017 },
      { pct: 90, speed: 13.0, power: 2540 },
      { pct: 100, speed: 16.0, power: 3192 }
    ],

    S6000: [
      { pct: 10, speed: 2.5, power: 104 },
      { pct: 20, speed: 4.0, power: 161 },
      { pct: 30, speed: 6.0, power: 353 },
      { pct: 40, speed: 7.5, power: 730 },
      { pct: 50, speed: 8.0, power: 1405 },
      { pct: 60, speed: 11.0, power: 2273 },
      { pct: 70, speed: 14.0, power: 3095 },
      { pct: 80, speed: 18.0, power: 4000 },
      { pct: 90, speed: 21.5, power: 5021 },
      { pct: 100, speed: 24.0, power: 6067 }
    ]
  };

  var CHART = {
    left: 70,
    top: 25,
    width: 600,
    height: 280,
    maxPower: 6500,
    maxSpeed: 26
  };

  function xFromPower(power) {
    return CHART.left + (power / CHART.maxPower) * CHART.width;
  }

  function yFromSpeed(speed) {
    return CHART.top + CHART.height - (speed / CHART.maxSpeed) * CHART.height;
  }

  function formatRuntime(hours) {
    if (!isFinite(hours) || hours <= 0) {
      return '0h 0m';
    }

    var h = Math.floor(hours);
    var m = Math.round((hours - h) * 60);

    if (m === 60) {
      h += 1;
      m = 0;
    }

    return h + 'h ' + m + 'm';
  }

  function buildGrid(root) {
    var grid = root.querySelector('[data-sw-grid]');
    if (!grid) return;

    var html = '';
    var speedTicks = [0, 5, 10, 15, 20, 25];
    var powerTicks = [0, 1500, 3000, 4500, 6000];

    speedTicks.forEach(function (speed) {
      var y = yFromSpeed(speed);

      html += '<line x1="' + CHART.left + '" y1="' + y + '" x2="' + (CHART.left + CHART.width) + '" y2="' + y + '"></line>';
      html += '<text x="56" y="' + (y + 4) + '" text-anchor="end">' + speed + '</text>';
    });

    powerTicks.forEach(function (power) {
      var x = xFromPower(power);

      html += '<line x1="' + x + '" y1="' + CHART.top + '" x2="' + x + '" y2="' + (CHART.top + CHART.height) + '"></line>';
      html += '<text x="' + x + '" y="326" text-anchor="middle">' + power + '</text>';
    });

    html += '<line x1="' + CHART.left + '" y1="' + CHART.top + '" x2="' + CHART.left + '" y2="' + (CHART.top + CHART.height) + '" stroke="#111827" stroke-width="2"></line>';
    html += '<line x1="' + CHART.left + '" y1="' + (CHART.top + CHART.height) + '" x2="' + (CHART.left + CHART.width) + '" y2="' + (CHART.top + CHART.height) + '" stroke="#111827" stroke-width="2"></line>';

    grid.innerHTML = html;
  }

  function getOutputs(root) {
    var outputs = {};
    var elements = root.querySelectorAll('[data-sw-out]');

    elements.forEach(function (element) {
      outputs[element.getAttribute('data-sw-out')] = element;
    });

    return outputs;
  }

  function getSelectedPlatform(root) {
    var selected = root.querySelector('[data-sw-platform]:checked');
    return selected ? selected.value : 'S6000';
  }

  function updateCalculator(root) {
    var platform = getSelectedPlatform(root);
    var points = SW_DATA[platform] || SW_DATA.S6000;

    var batteryInput = root.querySelector('[data-sw-battery]');
    var throttleInput = root.querySelector('[data-sw-throttle]');
    var curve = root.querySelector('[data-sw-curve]');
    var point = root.querySelector('[data-sw-point]');
    var tip = root.querySelector('[data-sw-tip]');
    var tipText = root.querySelector('[data-sw-tip-text]');
    var tableBody = root.querySelector('[data-sw-table]');
    var outputs = getOutputs(root);

    if (!batteryInput || !throttleInput || !curve || !point || !tableBody) {
      return;
    }

    var batteryWh = parseInt(batteryInput.value, 10);
    var throttle = parseInt(throttleInput.value, 10);

    var selectedPoint = points.find(function (item) {
      return item.pct === throttle;
    }) || points[0];

    var runtimeHours = batteryWh / selectedPoint.power;
    var rangeKm = runtimeHours * selectedPoint.speed;

    outputs.throttle.textContent = selectedPoint.pct + '%';
    outputs.speed.textContent = selectedPoint.speed.toFixed(1) + ' km/h';
    outputs.power.textContent = selectedPoint.power + ' W';
    outputs.runtime.textContent = formatRuntime(runtimeHours);
    outputs.range.textContent = rangeKm.toFixed(1) + ' km';
    outputs.battery.textContent = batteryWh + ' Wh';
    outputs.throttleBox.textContent = throttle + '%';

    var path = points.map(function (item, index) {
      var command = index === 0 ? 'M' : 'L';
      return command + ' ' + xFromPower(item.power) + ' ' + yFromSpeed(item.speed);
    }).join(' ');

    curve.setAttribute('d', path);

    var cx = xFromPower(selectedPoint.power);
    var cy = yFromSpeed(selectedPoint.speed);

    point.setAttribute('cx', cx);
    point.setAttribute('cy', cy);

    if (tip) {
      tip.setAttribute('transform', 'translate(' + cx + ',' + cy + ')');
    }

    if (tipText) {
      tipText.textContent = selectedPoint.power + ' W / ' + selectedPoint.speed.toFixed(1) + ' km/h';
    }

    tableBody.innerHTML = points.map(function (item) {
      var itemRuntime = batteryWh / item.power;
      var itemRange = itemRuntime * item.speed;
      var activeClass = item.pct === selectedPoint.pct ? ' class="is-active"' : '';

      return '<tr' + activeClass + '>' +
        '<td>' + item.pct + '%</td>' +
        '<td>' + item.speed.toFixed(1) + ' km/h</td>' +
        '<td>' + item.power + ' W</td>' +
        '<td>' + formatRuntime(itemRuntime) + '</td>' +
        '<td>' + itemRange.toFixed(1) + ' km</td>' +
      '</tr>';
    }).join('');
  }

  function initCalculator(root) {
    if (!root || root.getAttribute('data-sw-ready') === '1') {
      return;
    }

    root.setAttribute('data-sw-ready', '1');

    var platformInputs = root.querySelectorAll('[data-sw-platform]');
    var batteryInput = root.querySelector('[data-sw-battery]');
    var throttleInput = root.querySelector('[data-sw-throttle]');

    buildGrid(root);

    platformInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (batteryInput && input.getAttribute('data-default-battery')) {
          batteryInput.value = input.getAttribute('data-default-battery');
        }

        updateCalculator(root);
      });
    });

    if (batteryInput) {
      batteryInput.addEventListener('input', function () {
        updateCalculator(root);
      });
    }

    if (throttleInput) {
      throttleInput.addEventListener('input', function () {
        updateCalculator(root);
      });
    }

    updateCalculator(root);
  }

  function initAllCalculators() {
    var calculators = document.querySelectorAll('[data-sw-opc]');

    calculators.forEach(function (root) {
      initCalculator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCalculators);
  } else {
    initAllCalculators();
  }

  document.addEventListener('shopify:section:load', function () {
    initAllCalculators();
  });
})();